<template>
  <div>
    <h2 class="title is-size-5-mobile">{{ $t('general.overview') }}</h2>
    <Separator />

    <!-- INSURANCE START -->
    <!-- <h3 class="title is-size-5">Gewählte Versicherung</h3>
    <div class="columns is-gapless">
      <div class="column has-text-weight-bold">
        Hotelname
      </div>
      <div class="column">
        Storno-Paket inkl. Gutscheingarantie
      </div>
    </div>
    <b-button type="is-light" @click="changeInsurance">Versicherung anpassen</b-button>

    <Separator /> -->

    <!-- INSURANCE END -->

    <h3 class="title is-size-5">{{ $t('general.your-data') }}</h3>
    <div class="columns">
      <div class="column">
        <h4 class="title is-size-6 mb-0">{{ $t('general.user-data') }}</h4>
        <p v-if="customer">
          {{ customerName }}
          <br />{{ customer.email }} <br />{{ customer.phone }}
        </p>
      </div>
      <div class="column">
        <h4 class="title is-size-6 mb-0">{{ $t('general.address-data') }}</h4>
        <p>
          {{ customer.address }}
          <br />{{ customer.country }}-{{ customer.zip }} {{ customer.city }}
        </p>
      </div>
    </div>
    <b-button type="is-dark" @click="changeCustomerData">{{ $t('general.edit-data') }}</b-button>

    <Separator />
    <h3 class="title is-size-5">{{ $t('payment.chosen_payment') }}</h3>
    <div class="columns">
      <div class="column is-4" v-if="payment.paymentTypeId !== 5 && payment.paymentTypeId !== 20">
        <img v-lazy="`/img/payment/payment_${payment.paymentTypeId}.svg`" width="150" height="36" :alt="payment.paymentTypeName" loading="lazy" />
      </div>
      <div class="column">{{ $t(`payment.providers.${payment.paymentTypeName}`) }}</div>
    </div>
    <div class="buttons" v-if="payment.paymentTypeId !== 20">
      <AmazonChangePaymentButton />
      <b-button type="is-dark" @click="changePayment">{{ $t('payment.change_payment') }}</b-button>
    </div>

    <Separator />
    <div class="field">
      <b-checkbox @input="tosTrigger">
        {{ $t('payment.consent.agb_accept_1') }}
        <a :href="`/${tosPageSlug}`" :title="$t('payment.consent.agb_accept_2')" target="_blank">{{ $t('payment.consent.agb_accept_2') }}</a> {{ $t('payment.consent.agb_accept_3') }}
        <a :href="`/${privacyPageSlug}`" :title="$t('payment.consent.agb_accept_4')" target="_blank">{{ $t('payment.consent.agb_accept_4') }}</a>
        {{ $t('payment.consent.agb_accept_5') }}
        <span class="is-sr-only">{{ $t('payment.consent.sr-info') }}</span>
      </b-checkbox>
    </div>

    <AdacOptin />
    <NewsletterOptin />
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Separator from '@/components/Separator'
import AdacOptin from './AdacOptin'
import NewsletterOptin from './NewsletterOptin'
import AmazonChangePaymentButton from './AmazonChangePaymentButton'
export default {
  name: 'Overview',
  components: {
    Separator,
    AdacOptin,
    NewsletterOptin,
    AmazonChangePaymentButton,
  },
  props: {
    customer: Object,
    payment: Object,
  },
  data() {
    return {
      privacyPageSlug: '',
      tosPageSlug: '',
    }
  },
  computed: {
    ...mapGetters({
      pages: 'pages',
    }),
    customerName() {
      let ret = ''
      if (this.customer) {
        if (this.customer.sex == 0) {
          ret += 'Herr '
        } else if (this.customer.sex == 1) {
          ret += 'Frau '
        }
        if (this.customer.firstName) {
          ret += this.customer.firstName + ' '
        }
        if (this.customer.lastName) {
          ret += this.customer.lastName + ' '
        }
      }
      return ret
    },
  },
  methods: {
    changeInsurance() {
      this.$emit('back-to-insurance')
    },
    changeCustomerData() {
      this.$emit('back-to-customer')
    },
    changePayment() {
      this.$emit('back-to-payment')
    },
    tosTrigger(val) {
      this.$emit('tos-changed', val)
    },
  },
  mounted() {
    //temporary replacement for static urls
    //requires pages with name "tos" and "privacy-policy"
    //this pages should be tagged that they can be renamed individually
    this.pages.find(page => {
      if (page.name === 'tos') {
        this.tosPageSlug = page.slug
      }
      if (page.name === 'privacy-policy') {
        this.privacyPageSlug = page.slug
      }
    })
  },
}
</script>

<style scoped lang="sass"></style>
